import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Brand Design',
    description: 'Create a memorable brand with our design services. We craft unique visual elements that reflect your brand’s identity and differentiate you from competitors.',
  },
  {
    icon: <FaLock />,
    title: 'Brand Identity',
    description: 'Establish a strong brand identity that resonates with your audience. Our services include logo creation, color schemes, and brand messaging to build a cohesive image.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Brand Positioning',
    description: 'Position your brand effectively in the market. We develop strategies that highlight your unique value propositions and attract your target audience.',
  },
  {
    icon: <FaDesktop />,
    title: 'Engagement Strategy',
    description: 'Increase brand engagement with tailored strategies. We design campaigns that connect with your audience and foster meaningful interactions with your brand.',
  },
  {
    icon: <FaDesktop />,
    title: 'Google Profile Creation',
    description: 'Enhance your online visibility with a well-optimized Google Profile. We create and manage your Google My Business profile to improve local search results.',
  },
  {
    icon: <FaDesktop />,
    title: 'GBP Optimization',
    description: 'Maximize your presence on Google Business Profile with optimization techniques. Improve your profile’s effectiveness to attract more local customers and increase engagement.',
  },
];

const BrandDevelopment = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Brand Development</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default BrandDevelopment
